var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobalAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 15",
    width: 35,
    height: 30,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34A3DC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.2,1.6c0,0.3-0.1,0.7-0.3,0.9l0.7,1.6C7.9,4,8.1,4,8.4,4c0.9,0,1.7,0.3,2.4,0.9l2.1-1.5c0,0,0-0.1,0-0.2 c0-0.9,0.7-1.6,1.6-1.6S16,2.3,16,3.2c0,0.9-0.7,1.6-1.6,1.6c-0.2,0-0.4,0-0.6-0.1l-2.1,1.5C11.9,6.6,12,7.1,12,7.6 c0,0.4-0.1,0.8-0.2,1.1l1.8,1.1c0.2-0.1,0.5-0.2,0.8-0.2c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6v0L11,10.1 c-0.7,0.7-1.6,1.1-2.6,1.1c-1.7,0-3.1-1.2-3.5-2.8H3C2.7,8.9,2.2,9.2,1.6,9.2C0.7,9.2,0,8.5,0,7.6S0.7,6,1.6,6C2.2,6,2.7,6.3,3,6.8 h1.9c0.2-0.8,0.7-1.5,1.3-2L5.5,3.2C4.6,3.1,4,2.4,4,1.6C4,0.7,4.7,0,5.6,0S7.2,0.7,7.2,1.6L7.2,1.6z M8.4,8.8 c0.7,0,1.2-0.5,1.2-1.2S9.1,6.4,8.4,6.4c-0.7,0-1.2,0.5-1.2,1.2S7.7,8.8,8.4,8.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalAnalytics);
export default __webpack_public_path__ + "static/media/global-analytics.e34c800136074a657836f82ceb3af429.svg";
export { ForwardRef as ReactComponent };